import React from 'react';

import { InlineError } from './InlineError';

export const Unauthorized = () => (
  <div
    data-testid="page-unauthorized"
    className="h100 w100 dF jcC aiC beta fdC"
  >
    <InlineError text="Sorry, you don't have access to this application. Please contact the administrator." />
  </div>
);
